import { LoadingLayout } from "./loading-layout";
import { LoadingText } from "./loading-text";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  50% {
      opacity: .5;
  }
`;

const horizontalAnimate = keyframes`
 0%, 100% {
        width: 25%;
    }
    50% {
        width: 75%;
    }
    75% {
        width: 100%;
    }
`;

const HorizontalBarchartLoadingWrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2px;
  align-items: start;
  margin: auto;
  height: 6rem /* 96px */;
  width: 8rem /* 128px */;
`;

const Skeleton = styled.div`
  flex: 1 1 0%;
  background-color: aliceblue;
  border-radius: 0.25rem /* 4px */;
  animation: ${horizontalAnimate} 1500ms ease-in-out infinite;
`;

export const HorizontalBarchartLoading = () => {
  return (
    <LoadingLayout>
      <HorizontalBarchartLoadingWrapper>
        <SkeletonWrapper>
          {[0, 150, 75, 500, 200].map((bar, index) => {
            return <Skeleton key={`skeleton_bar_${index}`}></Skeleton>;
          })}
        </SkeletonWrapper>
        <LoadingText />
      </HorizontalBarchartLoadingWrapper>
    </LoadingLayout>
  );
};
